module.exports = __webpack_public_path__ + "static/media/piercing-unselected.ddd1500b.png";